import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '10px',
    },
    dialogBodyCell: {
      borderWidth: '1px',
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: 'white',
      padding: '1px',
      textAlign: 'center',
      height: '40px',
    },
    dialogBodyCellLeft: {
      borderWidth: '1px',
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: 'white',
      padding: '1px',
      paddingLeft: '10px',
      textAlign: 'left',
      height: '40px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },


    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '100%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
    textFieldDialog: {
      flexGrow: 1,
      height: '100%',
      width: '95%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
  })
);

export const DeviceRegistPageStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 316px)',
      overflowX: 'scroll',
    },
    tableDialgContainer: {
      maxHeight: 'calc(100vh - 276px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
